// extracted by mini-css-extract-plugin
module.exports = {"scrollShadow":"ModalBox_scrollShadow__7hQO-"};